import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@material-ui/core";
import {
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Checkbox,
} from "@mui/material";
import Sidebar from "./Sidebar"; // Import your Sidebar component
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";



const Management = () => {
  const [userList, setUserList] = useState([]);
  const [providerList, setProviderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedType, setSelectedType] = useState("user");
  const [selectedValue, setSelectedValue] = useState("");
  const [licenseNo, setLicenseNo] = useState("");
  const [address, setAddress] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedActiveItems, setselectedActiveItems] = useState([]);
  const [selectedInactiveItems, setselectedInactiveItems] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    console.log("selectedType:", selectedType);
  }, [selectedType]);

  const handleChangeType = (event) => {
    setSelectedType(event.target.value);
    setCurrentPage(1); // Reset to the first page when changing type
  };

  const handleChangeValue = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleCheck = (item, isChecked) => {
    setSelectedUser(item);
    if (selectedType === "provider") {
      if (isChecked) {
        if (item?.status === "ACTIVE") {
          setselectedInactiveItems([...selectedInactiveItems, item?.providerId]);
        } else {
          setselectedActiveItems([...selectedActiveItems, item?.providerId]);
        }
        setSelectedItems([...selectedItems, item?.providerId]);
      } else {
        setselectedInactiveItems(
          selectedInactiveItems.filter((selectedId) => selectedId !== item?.providerId)
        );
        setselectedActiveItems(
          selectedActiveItems.filter((selectedId) => selectedId !== item?.providerId)
        );
        setSelectedItems(
          selectedItems.filter((selectedId) => selectedId !== item?.providerId)
        );
      }
    } else {
      if (isChecked) {
        if (item?.status === "ACTIVE") {
          setselectedInactiveItems([...selectedInactiveItems, item?.userId]);
        } else {
          setselectedActiveItems([...selectedActiveItems, item?.userId]);
        }
        setSelectedItems([...selectedItems, item?.userId]);
      } else {
        setselectedInactiveItems(
          selectedInactiveItems.filter((selectedId) => selectedId !== item?.userId)
        );
        setselectedActiveItems(
          selectedActiveItems.filter((selectedId) => selectedId !== item?.userId)
        );
        setSelectedItems(
          selectedItems.filter((selectedId) => selectedId !== item?.userId)
        );
      }
    }
  };

  const handleDeactivate = async () => {
    try {
      const token = localStorage.getItem("token");
      const Activeids = Array.isArray(selectedActiveItems)
        ? selectedActiveItems
        : [selectedActiveItems];
      const Inactiveids = Array.isArray(selectedInactiveItems)
        ? selectedInactiveItems
        : [selectedInactiveItems];

      if (Activeids.length > 0) {
        await axios.post(
          `https://admin.yelospace.com/${selectedType}/update-status/1`,
          Activeids,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      if (Inactiveids.length > 0) {
        await axios.post(
          `https://admin.yelospace.com/${selectedType}/update-status/0`,
          Inactiveids,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      setSelectedItems([]);
      setselectedInactiveItems([]);
      setselectedActiveItems([]);
      fetchData(currentPage); // Refresh data after activation or deactivation
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [selectedType, currentPage]);

  const fetchData = async (page) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      let response;
      if (selectedType === "user") {
        response = await axios.get(`https://admin.yelospace.com/user-list?page=${page - 1}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserList(response?.data?.response?.users || []);
      } else if (selectedType === "provider") {
        response = await axios.get(`https://admin.yelospace.com/provider-list?page=${page - 1}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setProviderList(response?.data?.response?.providers || []);
      }
      setTotalItems(response?.data?.response?.totalItems || 0);
      setTotalPages(response?.data?.response?.totalPages || 1);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const currentItems =
    selectedType === "user"
      ? userList
      : providerList;

  return (
    <Container style={{ display: "flex", marginTop: "20px" }}>
      <Sidebar />
      <ToastContainer />
      <div style={{ flex: "1", marginLeft: "20vw" }}>
        <Typography
          variant="h6"
          style={{
            color: "#F5C000",
            fontWeight: "bold",
            marginBottom: "12px",
            marginTop: "24px",
          }}
        >
          {selectedType === "user" ? "User" : "Provider"} Management
        </Typography>
        <Paper
          elevation={0}
          style={{ width: "100%", border: "1px solid #fee9c5" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px",
              borderBottom: "1px solid #F5C000",
            }}
          >
            <Typography variant="body1" component="p">
              {selectedType === "user" ? "Users" : "Providers"} ({totalItems})
            </Typography>
            <div style={{ display: "flex" }}>
              <Button
                variant="contained"
                style={{
                  color: "#000",
                  borderRadius: "12px",
                  backgroundColor: "#F5C000",
                  boxShadow: "none",
                  border: "1px solid #F5C000",
                  marginRight: "10px",
                }}
                onClick={() => handleDeactivate()}
                disabled={selectedItems.length === 0}
              >
                Change Status
              </Button>

              <FormControl variant="outlined">
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedType}
                  onChange={handleChangeType}
                  style={{
                    minWidth: "120px",
                    color: "#000",
                    borderRadius: "12px",
                    boxShadow: "none",
                    border: "1px solid #F5C000",
                  }}
                >
                  <MenuItem value={"user"}>User</MenuItem>
                  <MenuItem value={"provider"}>Provider</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
          <TableContainer>
            <Table style={{ border: "1.5px solid #fee9c5" }}>
              <TableHead>
                <TableRow style={{ borderBottom: "1.5px solid #fee9c5" }}>
                  <TableCell></TableCell>
                  <TableCell>
                    <b>Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Email</b>
                  </TableCell>
                  <TableCell>
                    <b>Mobile Number</b>
                  </TableCell>
                  {selectedType === "provider" && (
                    <>
                      <TableCell>
                        <b>License No</b>
                      </TableCell>
                      <TableCell>
                        <b>Address</b>
                      </TableCell>
                    </>
                  )}
                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {currentItems.map((item) => (
                  <TableRow
                    key={item.id}
                    style={{ borderBottom: "1.5px solid #fee9c5" }}
                  >
                    <TableCell>
                      {selectedType === "provider" ? (
                        <Checkbox
                          style={{ color: "#F5C000" }}
                          checked={selectedItems.includes(item?.providerId)}
                          onChange={(event) =>
                            handleCheck(item, event.target.checked)
                          }
                        />
                      ) : (
                        <Checkbox
                          style={{ color: "#F5C000" }}
                          checked={selectedItems.includes(item?.userId)}
                          onChange={(event) =>
                            handleCheck(item, event.target.checked)
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell>{`${item.firstName} ${item.lastName}`}</TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{item.mobile}</TableCell>
                    {selectedType === "provider" && (
                      <>
                        <TableCell>{item.licenseNo}</TableCell>
                        <TableCell>{item.address}</TableCell>
                      </>
                    )}
                    <TableCell>{item.status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {[...Array(totalPages)].map((_, index) => (
            <Button
              key={index}
              variant="contained"
              style={{
                borderRadius: "20px",
                marginRight: "5px",
                backgroundColor:
                  currentPage === index + 1 ? "#5F5F61" : "white",
                color: currentPage === index + 1 ? "white" : "#5F5F61",
              }}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Button>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default Management;
